import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import './sass/main.scss';
import './js/scroll.js';
import './js/main.js';
import './js/lazy.js';